import { formatCnpjCpf, formatCurrency } from "@/common/utils/formatters";
import { strategy as kindStrategy } from "@/features/companies/constants/kind.constant.ts";
import { CompanyData } from "@/features/companies/types/companies.type";
import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";
import { companyStatus } from "../constants/companyStatus";
import { CardsTotalizerData } from "@/features/cards/types/cardsTotalizer.type";
import CompanyCardsHoverCard from "../components/CardsHoverCard";

export class CompaniesTransformer {
  static tableTransformer(setCompanyIdToSeeCardsInfo: (companyId: string) => void, cardsTotalizer: CardsTotalizerData, isPendingCards: boolean) {
    return (companies: CompanyData[]) => {
      return companies.map((company) => {
        const rawUnpaidCredit = company.kind === 'private_company' 
          ? company?.unpaid_consumed_credit
          : company?.unpaid_total

        const unpaid_consumed_credit = rawUnpaidCredit
          ? formatCurrency(parseFloat(rawUnpaidCredit)) 
          : 'Não informado'

        return {
          ...company,
          status: (company.status && companyStatus[company.status]) || '--',
          fantasy_name: company?.general_information?.fantasy_name || 'Não informado',
          kind: kindStrategy[company.kind as keyof typeof kindStrategy],
          granted_credit: company?.granted_credit ? formatCurrency(parseFloat(company?.granted_credit)) : 'Não informado',
          consumed_credit: company?.consumed_credit ? formatCurrency(parseFloat(company?.consumed_credit)) : 'Não informado',
          unpaid_consumed_credit,
          remaining_credit: company?.remaining_credit ? formatCurrency(parseFloat(company?.remaining_credit)) : 'Não informado',
          enabled_cards_count: (
            <div className="flex gap-2 items-center">
              {company.enabled_cards_count}
              <CompanyCardsHoverCard
                setCompanyIdToSeeCardsInfo={setCompanyIdToSeeCardsInfo}
                cardsTotalizer={cardsTotalizer}
                isPendingCards={isPendingCards}
                companyId={company.id}
              />
            </div>
          ),
          actions: <Link to={`/companies/${company.id}`} data-testid="access_company_button"><ArrowBigRight /></Link>
        };
      });
    };
  }

  static optionsTransformer() {
    return (companies: CompanyData[]) => {
      return companies.map((company) => {
        return {
          value: company.id,
          label: `${company?.general_information?.fantasy_name} \n${company?.general_information?.cnpj && formatCnpjCpf(company?.general_information?.cnpj)}` || '',
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (companies: CompanyData[]) => {
      return companies.map((company) => ({
        route: `/companies/${company.id}`,
        items: [
          ['Tipo', kindStrategy[company.kind as keyof typeof kindStrategy]],
          ['Nome', company?.general_information?.fantasy_name],
        ]
      }));
    };
  }
}
